import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { tabConfig, tokens } from '../../constants';
import { getCurrentEventControlState } from '../../utils';
export var getTabStyles = (props, pressableState) => {
  var _a, _b, _c, _d, _e, _f;
  var type = props.type,
    size = props.size,
    selected = props.selected,
    controlState = props.controlState,
    config = props.config;
  var tabSelectionType = selected ? 'selected' : 'default';
  var typeConfig = (_a = config === null || config === void 0 ? void 0 : config.type) === null || _a === void 0 ? void 0 : _a[type];
  var borderBottomWidth = typeConfig.borderBottomWidth,
    borderRadius = typeConfig.borderRadius;
  var styleBasedOnControlState = (_c = (_b = typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.selectionState) === null || _b === void 0 ? void 0 : _b[tabSelectionType]) === null || _c === void 0 ? void 0 : _c.controlStates;
  var eventState = getCurrentEventControlState(pressableState, controlState);
  var sizeBasedSize = (_e = (_d = config === null || config === void 0 ? void 0 : config.size) === null || _d === void 0 ? void 0 : _d[size]) === null || _e === void 0 ? void 0 : _e[type];
  var minHeight = sizeBasedSize.minHeight,
    paddingHorizontalToken = sizeBasedSize.paddingHorizontal;
  var styleBasedOnEvent = styleBasedOnControlState === null || styleBasedOnControlState === void 0 ? void 0 : styleBasedOnControlState[eventState];
  var backgroundColor = styleBasedOnEvent.backgroundColor,
    borderColor = styleBasedOnEvent.borderColor,
    color = styleBasedOnEvent.color;
  var spacingTokens = tokens.spacing;
  var borderRadiusValue = borderRadius && ((_f = tokens.borderRadius) === null || _f === void 0 ? void 0 : _f[borderRadius]);
  var SPACING_4 = spacingTokens === null || spacingTokens === void 0 ? void 0 : spacingTokens.SPACING_4;
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor,
      borderBottomWidth,
      borderColor,
      borderRadius: borderRadiusValue,
      minHeight,
      paddingHorizontal: spacingTokens === null || spacingTokens === void 0 ? void 0 : spacingTokens[paddingHorizontalToken]
    },
    icon: {
      color,
      marginRight: SPACING_4
    },
    label: {
      color
    },
    notifier: {
      marginLeft: SPACING_4
    }
  });
};
export var getTabFontTypes = selected => {
  return selected ? 'body-single-line-sm-bold' : 'body-single-line-sm';
};
export var getTabProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(tabConfig === null || tabConfig === void 0 ? void 0 : tabConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.tab) === null || _a === void 0 ? void 0 : _a[theme]);
  var controlState = (props === null || props === void 0 ? void 0 : props.disabled) && 'disabled' || (props === null || props === void 0 ? void 0 : props.controlState) || (configProps === null || configProps === void 0 ? void 0 : configProps.controlState);
  return Object.assign(Object.assign(Object.assign({
    theme
  }, configProps), props), {
    controlState
  });
};